const initToggleSearch = ($el) => {
    $el.click(($div) => {
        if(!$('.header__search-foldout').hasClass('header__search-foldout--is-open') && ($('.nav-service').hasClass('nav-service--slide-in'))){
            //hide mobile nav
            $('.js-toggle-menu').click();
        }

        const current = $('.header__search-foldout').attr('aria-expanded') === 'true';
        $('.header__search-foldout').attr('aria-expanded', !current);

        $('.nav-service__container').toggleClass('activesearch');
        $('.header__search__button').toggleClass('active');
        $('.nav-service__search__button').toggleClass('active');
        $('.header__search-foldout').toggleClass('header__search-foldout--is-open');
        $('#search').focus();
    });

    $('.header__search-foldout__close').click( function() {
        hideSearch();
    });

    $(document).on('keyup', function(e) {
        if (e.keyCode == "27") {
            hideSearch();
        }
    });

    $(window).on('click', function(e) {
        if (e.target.classList.contains('header__search-foldout')) {
            hideSearch();
        }
    });


    function hideSearch() {
        $('.nav-service__container').removeClass('activesearch');
        $('.header__search__button').removeClass('active');
        $('.nav-service__search__button').removeClass('active');
        $('.header__search-foldout').removeClass('header__search-foldout--is-open');
        $('.header__search-foldout').attr('aria-expanded', 'false');
        $('#search').blur();
    }

};



export default initToggleSearch;
